import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBIntField } from './DBIntField';

class DBIntFieldObjective extends React.Component {

    handleValueChange(e) {
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }else{
            if(typeof this.props.onChange === 'function'){
                this.props.onChange(e);
            }
           
        }
    }

    render() {
        return (
            <DBIntField
                noteId={this.props.noteId}
                entity={this.props.entity}
                entityKeyColumn={this.props.entityKeyColumn}
                entityKeyValue={this.props.entityKeyValue}
                field={this.props.field}
                className={this.props.className}
                title={this.props.title}
                min={this.props.min}
                max={this.props.max}
                onChange={(e) => this.handleValueChange(e)}
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteType = parseInt(ownprops.noteId.split("_")[0]);
    let pk = parseInt(ownprops.noteId.split("_")[1]);
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        objUpdated,
        pk
    };
}

const connectedDBIntFieldObjective = connect(mapStateToProps, mapDispatchToProps)(DBIntFieldObjective);
export { connectedDBIntFieldObjective as DBIntFieldObjective };